const DEFAULT_LOCALE = 'en'

function getDocumentLocale() {
  if (typeof document === 'undefined') return DEFAULT_LOCALE

  return document.documentElement?.lang || DEFAULT_LOCALE
}

function sanitizeLocale(locale) {
  return locale.toLowerCase().replace('_', '-')
}

function buildLocalizedPath(path = '/') {
  const locale = sanitizeLocale(getDocumentLocale())
  const normalizedPath = path.startsWith('/') ? path : `/${path}`

  if (locale === DEFAULT_LOCALE) {
    return normalizedPath
  }

  return `/${locale}${normalizedPath}`
}

export { buildLocalizedPath }
